export class WorklistSettingsDto {
    worklistDescription: string;
    worklistSuggestedDescription: string;
    worklistUpdatePending: boolean;

}